// core version + navigation, pagination modules:
import Swiper, {
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
  Thumbs,
} from 'swiper';

import { mobileMatchMedia } from './common';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs]);

class Carousel {
  constructor(swiperContainer, parameters = {}) {
    this.container = swiperContainer;
    this.parameters = parameters;
    this.instance = null;
  }

  active() {
    this.instance = new Swiper(this.container, this.parameters);
  }

  inactive() {
    if (this.instance !== null) {
      this.instance.destroy();
      this.instance = null;
    }
  }
}

function sliderKv() {
  const containerElements = document.querySelectorAll(
    '.p-kvTOP__sliderContainer',
  );
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      swiper.active();
    });
  };

  containerElements.forEach((element) => {
    if ('swiper' in element) return;

    const slides = element.querySelectorAll('.swiper-slide');

    carouselInstance.push(
      new Carousel(element, {
        // pagination: {
        //   el: element.querySelector('.swiper-pagination'),
        //   clickable: true,
        // },
        effect: 'fade',
        slidesPerView: 1,
        speed: 2000,
        loop: slides.length > 1,
        watchOverflow: slides.length < 2,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
      }),
    );
  });
  carousel();
}

function sliderBest() {
  // Thumbnail
  const sliderBestThumbnail = new Swiper(
    document.querySelector('.c-sliderBest__thumbnail .swiper-container'),
    {
      slidesPerView: 4,
      speed: 1000,
    },
  );

  // Main
  // eslint-disable-next-line no-new
  new Swiper(document.querySelector('.c-sliderBest__container'), {
    navigation: {
      nextEl: document.querySelector('.swiper-button-next'),
    },
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    speed: 1000,
    thumbs: {
      swiper: sliderBestThumbnail,
    },
    on: {
      slideChangeTransitionStart() {
        const thumbnailSlides = sliderBestThumbnail.slides;
        const thumbnailLength = thumbnailSlides.length;
        const activeThumbnailIndex = thumbnailSlides.findIndex((slide) =>
          slide.classList.contains('swiper-slide-thumb-active'),
        );

        thumbnailSlides.forEach((slide, index) => {
          if (slide.classList.contains('_first')) {
            slide.classList.remove('_first');
          }
          if (slide.classList.contains('_second')) {
            slide.classList.remove('_second');
          }
          if (slide.classList.contains('_third')) {
            slide.classList.remove('_third');
          }

          if (activeThumbnailIndex + 1 === index) {
            slide.classList.add('_first');
          } else if (
            activeThumbnailIndex === thumbnailLength - 1 &&
            index === 0
          ) {
            slide.classList.add('_first');
          } else if (activeThumbnailIndex + 2 === index) {
            slide.classList.add('_second');
          } else if (
            activeThumbnailIndex === thumbnailLength - 2 &&
            index === 0
          ) {
            slide.classList.add('_second');
          } else if (
            activeThumbnailIndex === thumbnailLength - 1 &&
            index === 1
          ) {
            slide.classList.add('_second');
          } else if (activeThumbnailIndex + 3 === index) {
            slide.classList.add('_third');
          } else if (
            activeThumbnailIndex === thumbnailLength - 3 &&
            index === 0
          ) {
            slide.classList.add('_third');
          } else if (
            activeThumbnailIndex === thumbnailLength - 2 &&
            index === 1
          ) {
            slide.classList.add('_third');
          } else if (
            activeThumbnailIndex === thumbnailLength - 1 &&
            index === 2
          ) {
            slide.classList.add('_third');
          }
        });
      },
      slideChangeTransitionEnd() {
        const thumbnailSlides = sliderBestThumbnail.slides;
        const activeThumbnailIndex = thumbnailSlides.findIndex((slide) =>
          slide.classList.contains('swiper-slide-thumb-active'),
        );

        thumbnailSlides.forEach((slide, index) => {
          if (activeThumbnailIndex === index) {
            slide.classList.remove('swiper-slide-thumb-active');
          }
        });
      },
    },
  });
}

function sliderColumn1() {
  const containerElements = document.querySelectorAll(
    '.c-sliderColumn1__container',
  );
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      swiper.active();
    });
  };

  containerElements.forEach((element) => {
    if ('swiper' in element) return;

    const slides = element.querySelectorAll('.swiper-slide');

    carouselInstance.push(
      new Carousel(element, {
        navigation: {
          prevEl: element.querySelector('.swiper-button-prev'),
          nextEl: element.querySelector('.swiper-button-next'),
        },
        pagination: {
          el: element.querySelector('.swiper-pagination'),
          clickable: true,
        },
        autoHeight: true,
        effect: 'fade',
        slidesPerView: 1,
        speed: 1000,
        loop: slides.length > 1,
        watchOverflow: slides.length < 2,
        autoplay: {
          delay: 5000,
        },
        on: {
          slideChange() {
            if (this.realIndex === 0) {
              this.autoplay.stop();
            }
          },
        },
      }),
    );
  });
  carousel();
}

function sliderColumn4() {
  const containerElements = document.querySelectorAll(
    '.c-sliderColumn4__container',
  );
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      swiper.active();
    });
  };

  containerElements.forEach((element) => {
    if ('swiper' in element) return;

    const slides = element.querySelectorAll('.swiper-slide');

    carouselInstance.push(
      new Carousel(element, {
        navigation: {
          prevEl: element.querySelector('.swiper-button-prev'),
          nextEl: element.querySelector('.swiper-button-next'),
        },
        speed: 1000,
        spaceBetween: 15,
        slidesPerView: 2,
        watchOverflow: slides.length < 3,
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesPerView: 4,
            watchOverflow: slides.length < 5,
          },
        },
      }),
    );
  });
  carousel();
}

function sliderDetail() {
  const blockGalleryElements = document.querySelectorAll('.c-sliderDetail');

  blockGalleryElements.forEach((element) => {
    const slides = element.querySelectorAll('.swiper-slide');

    const galleryThumbs = new Swiper(
      element.querySelector('.c-sliderDetail__thumbnailContainer'),
      {
        loop: false,
        slidesPerView: 'auto',
      },
    );

    // eslint-disable-next-line no-new
    new Swiper(element.querySelector('.c-sliderDetail__mainContainer'), {
      effect: 'fade',
      slidesPerView: 1,
      speed: 1000,
      watchOverflow: slides.length < 3,
      navigation: {
        prevEl: element.querySelector('.swiper-button-prev'),
        nextEl: element.querySelector('.swiper-button-next'),
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
  });
}

function sliderLead() {
  const triggerSlideCount = 5;
  const wrapperElement = document.querySelector('.c-sliderLead__wrapper');
  if (wrapperElement === null) {
    return;
  }
  const slideElementCount = wrapperElement.childElementCount;
  if (slideElementCount < triggerSlideCount) {
    document.querySelector('.c-sliderLead').classList.add('_noSlider');
    return;
  }

  const containerElements = document.querySelectorAll(
    '.c-sliderLead__container',
  );
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      swiper.active();
    });
  };

  containerElements.forEach((element) => {
    if ('swiper' in element) return;

    const slides = element.querySelectorAll('.swiper-slide');

    carouselInstance.push(
      new Carousel(element, {
        navigation: {
          prevEl: element.querySelector('.swiper-button-prev'),
          nextEl: element.querySelector('.swiper-button-next'),
        },
        speed: 500,
        spaceBetween: 15,
        slidesPerView: 2,
        watchOverflow: slides.length < 3,
        breakpoints: {
          768: {
            spaceBetween: 23,
            slidesPerView: 4,
            watchOverflow: slides.length < 5,
          },
        },
      }),
    );
  });
  carousel();
}

function sliderNews() {
  const containerElements = document.querySelectorAll(
    '.c-sliderNews__container',
  );
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      swiper.active();
    });
  };

  containerElements.forEach((element) => {
    if ('swiper' in element) return;

    carouselInstance.push(
      new Carousel(element, {
        speed: 1000,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        spaceBetween: 20,
        slidesPerView: 1.48,
        breakpoints: {
          768: {
            spaceBetween: 30,
            slidesPerView: 3.22,
          },
        },
      }),
    );
  });
  carousel();
}

function sliderMobile() {
  const containerElements = document.querySelectorAll('.js-slideMobile');
  const carouselInstance = [];
  const carousel = () => {
    carouselInstance.forEach((swiper) => {
      if (mobileMatchMedia.matches) {
        swiper.active();
      } else {
        swiper.inactive();
      }
    });
  };

  containerElements.forEach((element) => {
    if ('swiper' in element) return;

    const slides = element.querySelectorAll('.swiper-slide');

    carouselInstance.push(
      new Carousel(element, {
        navigation: {
          prevEl: element.querySelector('.swiper-button-prev'),
          nextEl: element.querySelector('.swiper-button-next'),
        },
        autoHeight: true,
        effect: 'fade',
        slidesPerView: 1,
        speed: 1000,
        loop: slides.length > 1,
        watchOverflow: slides.length < 2,
        autoplay: {
          delay: 5000,
        },
      }),
    );
  });

  mobileMatchMedia.addListener(carousel);
  carousel();
}

export default function slider() {
  sliderKv();
  sliderBest();
  sliderColumn1();
  sliderColumn4();
  sliderDetail();
  sliderLead();
  sliderNews();
  sliderMobile();
}
